import styled, { css } from 'styled-components'

export interface EventPriceStyledProps {
  $variant?: 'default' | 'primary'
  $size?: 'small' | 'medium' | 'large'
}

const sizeStyles = {
  small: css`
    .price {
      font-size: ${({ theme }) => theme.typography.fontSize.body};
    }
    .sub-price {
      font-size: ${({ theme }) => theme.typography.fontSize.micro};
    }
  `,
  medium: css`
    .price {
      font-size: ${({ theme }) => theme.typography.fontSize.section};
    }
    .sub-price {
      font-size: ${({ theme }) => theme.typography.fontSize.small};
    }
  `,
  large: css`
    .price {
      font-size: ${({ theme }) => theme.typography.fontSize.title};
    }
    .sub-price {
      font-size: ${({ theme }) => theme.typography.fontSize.body};
    }
  `,
}

const variantStyles = {
  default: css`
    .price {
      color: ${({ theme }) => theme.colors.text.primary};
    }
  `,
  primary: css`
    .price {
      color: ${({ theme }) => theme.colors.primary};
    }
  `,
}

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<EventPriceStyledProps>`
  display: flex;
  align-items: baseline;
  gap: 12px;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};

  .price {
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    margin: 0;
  }

  .sub-price {
    color: ${({ theme }) => theme.colors.text.secondary};
    margin: 0;
  }

  ${({ $size = 'medium' }) => sizeStyles[$size]}
  ${({ $variant = 'default' }) => variantStyles[$variant]}
`
